<template>
  <div class>
    <header class="header flex-box">
      <div @click="back" class="flex1 flex-box flex-v-c">
        <i class="iconfont icon-houtui"></i> 返回
      </div>
      <div
        class="headerTitle flex2 flex-box flex-hv-c"
      >{{managerId?'商务'+managerId:'我'}}的代理{{memberId}}详情</div>
      <div class="flex1"></div>
    </header>
    <div class="detailContent" v-cloak>
      <!-- 代理信息 -->
      <ul class="info">
        <li>
          <img class="avatar flex-box flex-v-c" :src="data.avatar" alt />
        </li>
        <li class="flex-box flex-v-c bb">
          <div class="flex1">
            <span>代理ID：</span>
            {{data.memberId}}
          </div>
          <div class="flex1">
            <span>真实姓名：</span>
            {{data.realname}}
          </div>
          <div class="flex1 flex-box">
            <span>状态：</span>
            <div :class="{tip:data.status==1,success:data.status==0}">{{data.status?'被封':'正常'}}</div>
          </div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div class="flex1">
            <span>游戏ID：</span>
            {{data.gameId}}
          </div>
          <div class="flex1">
            <span>昵称：</span>
            {{data.nickname}}
          </div>
          <div class="flex1">
            <span>地区：</span>
            {{data.district}}
          </div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div class="flex1">
            <span>身份：</span>
            我的{{data.hierarchy}}级代理
          </div>
          <div class="flex1">
            <span>上级代理：</span>
            {{data.referrerId}}
          </div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div class="flex1 flex-box">
            <span>剩余元宝：</span>
            <div class="tip">{{data.costMoney}}</div>
          </div>
          <div class="flex1 flex-box">
            <span>绑定玩家数：</span>
            <div class="tip">{{data.bindCount}}</div>
          </div>
          <div class="flex1 flex-box">
            <span>奖励金额：</span>
            <div class="tip">{{data.fanli}}</div>
          </div>
        </li>

        <li class="flex-box flex-v-c bb">
          <span>创建时间：</span>
          <div v-if="data.createTime">{{data.createTime|formatDate('yyyy/MM/dd hh:mm:ss')}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <span>授权类型：</span>
          {{['','代理授权','商务授权','CMS授权'][data.authType]}}
        </li>
        <li class="flex-box flex-v-c bb">
          <span>成为正式代理：</span>
          <div v-if="data.officialTime">{{data.officialTime|formatDate('yyyy/MM/dd hh:mm:ss')}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <span>上次登录：</span>
          <div v-if="data.lastLoginTime">{{data.lastLoginTime|formatDate('yyyy/MM/dd hh:mm:ss')}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <span>联系方式：</span>
          <div>{{data.mobileNum||data.alipayAccount}}</div>
        </li>
        <!-- 团队 -->
        <div class="team">
          <div class="flex-box flex-hv-c title">团队详情</div>
          <div class="flex-box flex-v-c picker bb">
            <div class="flex1 flex-box flex-hv-c startTime" @click="openPick('startTime')">
              {{startValue}}
              <span v-show="!startValue">{{begin|formatDateExp('yyyy/MM/dd')}}</span>
            </div>
            <div
              class="flex1 flex-box flex-hv-c endTime"
              @click="openPick('endTime')"
              style="margin: 0 6px;"
            >
              {{endValue}}
              <span v-show="!endValue">{{end|formatDateExp('yyyy/MM/dd')}}</span>
            </div>
            <div class="flex1 flex-box flex-hv-c" @click="search">
              <div class="button searchBtn">
                搜索
                <i class="iconfont icon-search"></i>
              </div>
            </div>
          </div>

          <ul>
            <li class="flex-box flex-v-c bb">
              直属团队开房数：
              <div class="tip">{{teamData.playCount}}</div>
            </li>
            <li class="flex-box flex-v-c bb">
              <div class="flex1">团队名称</div>
              <div class="flex1">总充值</div>
              <div class="flex1">总奖励</div>
            </li>
            <li class="flex-box flex-v-c bb">
              <div class="flex1">直属团队</div>
              <div class="flex1 tip">{{teamData.playerRecharge}}</div>
              <div class="flex1 tip">{{teamData.playerIncome}}</div>
            </li>
            <li class="flex-box flex-v-c bb">
              <div class="flex1">二级团队</div>
              <div class="flex1 tip">{{teamData.secondRecharge}}</div>
              <div class="flex1 tip">{{teamData.secondTeam}}</div>
            </li>
            <li class="flex-box flex-v-c bb" v-if="['js3mj','huaian','haian','xuzhou','jinzhong'].includes(env)">
              <div class="flex1">三级团队</div>
              <div class="flex1 tip">{{teamData.thirdRecharge}}</div>
              <div class="flex1 tip">{{teamData.thirdTeam}}</div>
            </li>
            <li class="flex-box">
              <div class="flex1">总计</div>
              <div class="flex1 tip">{{teamData.totalRecharge}}</div>
              <div class="flex1 tip">{{teamData.totalamount}}</div>
            </li>
          </ul>
        </div>

        <!-- 提示 -->
        <ul class="tipList">
          <div class="tip bb" style="padding:0 0 0.2rem 0">提示:</div>
          <li class="bb">
            我的玩家：当直属玩家产生充值后，分成比例为
            <span class="fanliTxt tip">{{Math.round((data.fanliTxt)*100)+"%"}}</span>。
          </li>
          <li class="bb">
            预备代理邀请人数没有达到
            <span class="lv1Bind tip">{{data.lv1Bind}}</span>人，不享受奖励分成。邀请人数达到
            <span class="lv1Bind tip">{{data.lv1Bind}}</span>人即可成为正式代理，开始享受奖励分成。
          </li>
          <li v-show="data.fanliTxt2" class="bb">
            获得二级代理
            <span class="fanliTxt2 tip">{{Math.round((data.fanliTxt2)*100)+"%"}}</span>的奖励，如果他的绑定人数不足
            <span class="lv1Bind tip">{{data.lv1Bind}}</span>时，
            <span class="tip">
              您依旧可以获得他元宝充值的
              {{Math.round((data.fanliTxt)*100)+"%"}}奖励，但无法获得他的团队奖励。
            </span>
          </li>
          <li v-if="['js3mj','huaian','haian','xuzhou','jinzhong'].includes(env)">
            获得三级代理2%的奖励，如果他的绑定人数不足
            <span class="lv1Bind tip">{{data.lv1Bind}}</span>时，无法获得他的团队奖励。
          </li>
        </ul>
      </ul>
    </div>
    <!-- 时间选择 -->
    <mt-datetime-picker
      ref="startTime"
      v-model="pickerValue"
      type="date"
      year-format="{value} 年"
      month-format="{value} 月"
      date-format="{value} 日"
      :startDate="startDate"
      :endDate="endDate"
      @confirm="handleConfirm('start')"
    ></mt-datetime-picker>
    <mt-datetime-picker
      ref="endTime"
      v-model="pickerValue2"
      type="date"
      year-format="{value} 年"
      month-format="{value} 月"
      date-format="{value} 日"
      :startDate="startDate"
      :endDate="endDate"
      @confirm="handleConfirm('end')"
    ></mt-datetime-picker>
  </div>
</template>
<!--javascript-->
<script>
export default {
  props: ['memberId', 'managerId'],
  data: function () {
    return {
      url: '/member/info',
      data: {},
      teamData: {},
      startValue: '',
      endValue: '',//默认显示
      pickerValue: '',
      pickerValue2: '',
      startDate: new Date('2016/01/1'),
      endDate: '',
      begin: new Date().getTime() - (7 * 24 * 3600 * 1000),//默认最近七天数据
      end: new Date().getTime(),
      sendData: {
        memberId: this.memberId
      },
      env : localStorage.getItem("env") || ''
    }
  },
  methods: {
    getData() {
      this.$http.get(this.url, { params: this.sendData }).then((res) => {
        if (res.code == 0) {
          this.data = res.data
        } else {
          this.$toast(res.message)
        }
      })
    },
    getTeamData() {
      if (this.end < this.begin) {
        this.$toast('结束时间不能小于开始时间');
        return
      }
      if (this.end - this.begin > (7 * 24 * 3600 * 1000)) {
        this.$toast('时间跨度不能大于一个星期(7天)');
        return;
      }
      this.$http.get('/team/incomeList', { params: { memberId: this.memberId, begin: this.begin, end: this.end } }).then((res) => {
        if (res.code == 0) {
          this.teamData = res.data
        } else {
          this.$toast(res.message)
        }
      })
    },
    /******
    * 打开时间选择
    * ***/
    openPick(param) {
      var that = this
      that.$refs[param].open()
    },
    /******
     * 确认时间
     * ***/
    handleConfirm(param) {
      if (param == 'start') {
        let d = new Date(this.pickerValue)
        let time = d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate()
        this.startValue = time
        this.begin = new Date(time).getTime()
      } else if (param == 'end') {
        let d = new Date(this.pickerValue2)
        let time = d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate()
        this.endValue = time
        this.end = new Date(time).getTime()
      }
    },
    search() {
      this.getTeamData()
    },
    back() {
      this.$emit('ctrDetails', false)
    }
  },
  mounted: function () {

  },
  created: function () {
    console.log(this.$store.state.userMsg.userMsg)
    if (this.managerId) {
      this.sendData.managerId = this.managerId
      this.url = '/subManager/memberInfo'
    }
    this.startDate = new Date(Number(localStorage.getItem("startTime")));
    this.endDate = new Date(Number(localStorage.getItem("endTime")));
    this.pickerValue = this.startDate.getFullYear() + '/' + (this.startDate.getMonth() + 1) + '/' + this.startDate.getDate();
    this.pickerValue2 = this.endDate.getFullYear() + '/' + (this.endDate.getMonth() + 1) + '/' + this.endDate.getDate();
    this.getData()
    this.getTeamData()
  }

}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.detail {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background: #fff;
  width: 100%;
  height: 100%;
}

.detailContent {
  -webkit-overflow-scrolling: touch;
  overflow: auto;
  height: calc(100vh - 1rem);
  padding: 10px;
}
ul li {
  min-height: 0.7rem;
  padding: 4px 0;
}
ul.info span {
  color: #999;
}
.tip {
  color: orangered !important;
}
.avatar {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
}
.tipList {
  border: 1px dashed #838799;
  border-radius: 6px;
  padding: 10px;
  li {
    padding: 0.2rem;
    position: relative;
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: -4px;
      -webkit-transform: translate(0, -50%);
      transform: translate(0, -50%);
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: orangered;
      display: block;
    }
  }
}

.team {
  margin: 0.5rem 0;
  .title {
    font-weight: bold;
    height: 0.7rem;
    margin-bottom: 0.2rem;
    border-top: 1px solid #3d435f;
    border-bottom: 1px solid #3d435f;
  }
}

.picker {
  height: 0.8rem;
}

.searchBtn {
  width: 100%;
  height: 0.6rem;
}

.startTime,
.endTime {
  height: 0.6rem;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/member/detail.vue